export default __webpack_public_path__ + "static/media/rmttmark-after.2cf2e779.png";